import { render } from "./AssignMenuItemsModifier.vue?vue&type=template&id=23c7c415&scoped=true"
import script from "./AssignMenuItemsModifier.vue?vue&type=script&lang=js"
export * from "./AssignMenuItemsModifier.vue?vue&type=script&lang=js"

import "./AssignMenuItemsModifier.vue?vue&type=style&index=0&id=23c7c415&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c7c415"]])

export default __exports__